import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";

DataTable.use(DT);

const EmailCampaignsTable = ({ emailCampaigns = [], onUpdated = () => { } }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [localEmailCampaigns, setLocalEmailCampaigns] = useState([]);
  const [filteredRowCount, setFilteredRowCount] = useState(0);

  useEffect(() => {
    console.log("!!! emailCampaigns: ", emailCampaigns);
    if (emailCampaigns) {
      setLocalEmailCampaigns(emailCampaigns);
      setFilteredRowCount(emailCampaigns.length);
    }
  }, [emailCampaigns]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (tableRef.current) {
        const dt = tableRef.current.dt();
        dt.on("search.dt", () => {
          const count = dt.rows({ search: "applied" }).count();
          setFilteredRowCount(count);
        });
        clearInterval(interval);
      } else {
        console.log("!!! TABLE REF IS NULL");
      }
    }, 10);
  }, []);

  window.formatDate = (date) => {
    const inputDate = new Date(date);

    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate =
      `${pad(inputDate.getDate())}-${pad(
        inputDate.getMonth() + 1
      )}-${inputDate.getFullYear()} ` +
      `${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}:${pad(
        inputDate.getSeconds()
      )} ` +
      `GMT${inputDate.toTimeString().slice(9, 14)} (${inputDate
        .toTimeString()
        .match(/\(([^)]+)\)/)[1]
        .split(" ")
        .map((w) => w[0])
        .join("")})`;
    return formattedDate;
  };

  window.edit = (public_id) => {
    navigate(`/admin/email-campaign/${public_id}`);
  };

  const tableData = localEmailCampaigns.map((emailCampaign) => {
    return [
      emailCampaign.id,
      emailCampaign.title,
      emailCampaign?.description ?? "",
      emailCampaign.scheduled_time ? new Date(emailCampaign.scheduled_time) : "Not Scheduled",
      emailCampaign?.email_count ?? 0,
      emailCampaign?.status ?? "unknown",
      `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${emailCampaign.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div`,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Email Campaigns ({filteredRowCount} of {localEmailCampaigns.length})
        <span
          style={{
            fontSize: "20px",
            fontWeight: "normal",
            marginLeft: "10px",
            cursor: "pointer",
          }}
          onClick={() => {
            window.edit("");
          }}
        >
          <i className="fas fa-plus"></i>
        </span>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[6, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Scheduled Time</th>
            <th>Email Count</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default EmailCampaignsTable;
